import React, { Component } from 'react';
import styled from 'styled-components';

import { media } from '../../utils/Helper';

interface OwnProps {
  text: string;
  backgroundColor: string;
  boldText?: boolean;
}
interface OwnState {}

const Div = styled.div`
  background-color: ${({ theme }) => theme.backgroundColor};
  padding-top: 8rem;
  padding-bottom: 8rem;
  text-align: center;
  margin-left: calc(((100vw - 100%) / 2) * -1);
  margin-right: calc(((100vw - 100%) / 2) * -1);
  ${media.tablet`padding-right:1.6rem;padding-left:1.6rem`}
`;

const TextDiv = styled.div<{ bold?: boolean }>`
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  margin-bottom: 3.2rem;
`;

class BottomSection extends Component<OwnProps, OwnState> {
  render() {
    return (
      <Div
        theme={{ backgroundColor: this.props.backgroundColor }}
        className="bottom-section"
      >
        <TextDiv bold={this.props.boldText}>{this.props.text}</TextDiv>
        {this.props.children}
      </Div>
    );
  }
}
export default BottomSection;
